import translations from './fields.translations'

export const FIELD_DEFAULT_MAX_LENGTH = 254

export const FIELD_REPORTED_ERRORS = {
  INVALID: 'invalid',
  UNAUTHORIZED: 'unauthorized',
}

export const ERROR_TRANSLATIONS = {
  postalCode: {
    [FIELD_REPORTED_ERRORS.INVALID]: translations.postalCodeInvalid,
    [FIELD_REPORTED_ERRORS.UNAUTHORIZED]: translations.postalCodeUnauthorized,
  },
}

export const FIELDS_STYLE = {
  JP: {
    name: { order: 1, shouldDisplay: true },
    lastName: { order: 101, shouldDisplay: true },
    firstName: { order: 102, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: true },
    lastNamePronunciation: { order: 201, shouldDisplay: true },
    firstNamePronunciation: { order: 202, shouldDisplay: true },
    country: { order: 3, shouldDisplay: true },
    postalCode: { order: 4, shouldDisplay: false },
    postalCodeAutocomplete: { order: 4, shouldDisplay: true },
    city: { order: 5, shouldDisplay: true },
    state: { order: 5, shouldDisplay: false },
    street: { order: 6, shouldDisplay: true },
    streetAutocomplete: { order: 6, shouldDisplay: false },
    street2: { order: 7, shouldDisplay: true },
    company: { order: 8, shouldDisplay: true },
    publicCompanyName: { order: 9, shouldDisplay: true },
    phone: { order: 10, shouldDisplay: true },
    nationalId: { order: 11, shouldDisplay: true },
  },
  US: {
    name: { order: 1, shouldDisplay: true },
    firstName: { order: 101, shouldDisplay: true },
    lastName: { order: 102, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: false },
    firstNamePronunciation: { order: 201, shouldDisplay: false },
    lastNamePronunciation: { order: 202, shouldDisplay: false },
    company: { order: 3, shouldDisplay: true },
    publicCompanyName: { order: 4, shouldDisplay: true },
    street: { order: 5, shouldDisplay: false },
    streetAutocomplete: { order: 5, shouldDisplay: true },
    street2: { order: 6, shouldDisplay: true },
    city: { order: 7, shouldDisplay: true },
    postalCode: { order: 7, shouldDisplay: true },
    postalCodeAutocomplete: { order: 7, shouldDisplay: false },
    state: { order: 8, shouldDisplay: false },
    country: { order: 9, shouldDisplay: true },
    phone: { order: 10, shouldDisplay: true },
    nationalId: { order: 11, shouldDisplay: true },
  },
  AU: {
    name: { order: 1, shouldDisplay: true },
    firstName: { order: 101, shouldDisplay: true },
    lastName: { order: 102, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: false },
    firstNamePronunciation: { order: 201, shouldDisplay: false },
    lastNamePronunciation: { order: 202, shouldDisplay: false },
    company: { order: 2, shouldDisplay: true },
    publicCompanyName: { order: 4, shouldDisplay: true },
    street: { order: 3, shouldDisplay: false },
    streetAutocomplete: { order: 3, shouldDisplay: true },
    street2: { order: 4, shouldDisplay: true },
    city: { order: 5, shouldDisplay: true },
    postalCode: { order: 6, shouldDisplay: true },
    postalCodeAutocomplete: { order: 6, shouldDisplay: false },
    state: { order: 7, shouldDisplay: false },
    country: { order: 2, shouldDisplay: true },
    phone: { order: 8, shouldDisplay: true },
    nationalId: { order: 11, shouldDisplay: true },
  },
  default: {
    name: { order: 1, shouldDisplay: true },
    firstName: { order: 101, shouldDisplay: true },
    lastName: { order: 102, shouldDisplay: true },
    namePronunciation: { order: 2, shouldDisplay: false },
    firstNamePronunciation: { order: 201, shouldDisplay: false },
    lastNamePronunciation: { order: 202, shouldDisplay: false },
    company: { order: 3, shouldDisplay: true },
    country: { order: 5, shouldDisplay: true },
    city: { order: 0, shouldDisplay: false },
    state: { order: 6, shouldDisplay: true },
    street: { order: 7, shouldDisplay: false },
    streetAutocomplete: { order: 7, shouldDisplay: true },
    street2: { order: 8, shouldDisplay: true },
    postalCode: { order: 9, shouldDisplay: true },
    postalCodeAutocomplete: { order: 9, shouldDisplay: false },
    phone: { order: 10, shouldDisplay: true },
    publicCompanyName: { order: 4, shouldDisplay: true },
    nationalId: { order: 11, shouldDisplay: true },
  },
}

export const FIELDS_TAB_INDEX = {
  JP: {
    firstName: 2,
    lastName: 1,
    firstNamePronunciation: 4,
    lastNamePronunciation: 3,
    company: 11,
    country: 5,
    city: 8,
    stateOrProvince: 7,
    street: 9,
    streetAutocomplete: 9,
    street2: 10,
    postalCode: 6,
    postalCodeAutocomplete: 6,
    phone: 13,
    publicCompanyName: 12,
    nationalId: 14,
  },
  AU: {
    firstName: 1,
    lastName: 2,
    company: 3,
    country: 4,
    city: 7,
    stateOrProvince: 7,
    street: 5,
    streetAutocomplete: 5,
    street2: 6,
    postalCode: 8,
    postalCodeAutocomplete: 8,
    phone: 9,
    publicCompanyName: 10,
    nationalId: 11,
  },
}
